import axios from 'axios';

let instancia = null;

const privateProps = new WeakMap();

class HttpClient {
	constructor(baseURL, token = null, timeout = 60000) {
		// Se já existe uma instância, atualizar suas propriedades
		if (instancia) {
			const props = privateProps.get(instancia);
			
			// Atualizar baseURL se fornecida
			if (baseURL && props.baseURL !== baseURL) {
				props.baseURL = baseURL;
				props.axios.defaults.baseURL = baseURL;
			}
			
			// Atualizar token se fornecido
			if (token !== null) {
				props.token = token;
				if (token) {
					props.axios.defaults.headers.common['Authorization'] = token;
				} else {
					delete props.axios.defaults.headers.common['Authorization'];
				}
			}
			
			return instancia;
		}
		
		instancia = this;
		let options = { baseURL: baseURL, timeout: timeout };
		let ax = axios.create(options);
		if (token) ax.defaults.headers.common['Authorization'] = token;
		privateProps.set(this, {
			axios: ax,
			baseURL: baseURL,
			timeout: timeout,
			token: token,
			cache: {}
		})
	}

	get axios() {
		return privateProps.get(this).axios;
	}

	get baseURL() {
		return privateProps.get(this).baseURL;
	}

	get timeout() {
		return privateProps.get(this).timeout;
	}

	get token() {
		return privateProps.get(this).token;
	}

	set token(val) {
		const props = privateProps.get(this);
		if (val) {
			props.token = val;
			props.axios.defaults.headers.common['Authorization'] = val;
		} else {
			props.token = null;
			delete props.axios.defaults.headers.common['Authorization'];
		}
	}

	set baseURL(val) {
		const props = privateProps.get(this);
		props.baseURL = val;
		props.axios.defaults.baseURL = val;
	}

	async getCache(options) {
		let cache = privateProps.get(this).cache;
		if (typeof cache[options.url] == 'undefined') {
			cache[options.url] = await this.axios(options)
		}
		return cache[options.url];
	}

	async send(endpoint, method, data, timeout, cache = true, headers) {
		let options = {
			method: method,
			url: endpoint,
		}
		if (data) {
			if (method == 'GET') {
				let query = '';
				let i = 0;
				for (let key in data) {
					if (i > 0) query += '&';
					query += encodeURIComponent(key) + '=' + encodeURIComponent(data[key]);
					i++;
				}
				options.url += '?' + query;
			} else {
				cache = false;
				options.data = data;
			}
		}
		if (headers) {
			options.headers = headers;
		}

		if (timeout) options.timeout = timeout;
		try {
			let response;
			if (cache) {
				response = await this.getCache(options);
			} else {
				response = await this.axios(options);
			}
			return response;
		} catch (e) {
			if (!e.response) {
				var data = {
					status: 500,
					data: {
						retorno: e.message
					}
				}
				return data;
			} else {
				return e.response;
			}
		}
	}
}

export default HttpClient;